<template>
  <div class="root">
    <v-container class="pt-0" :class="{ fixed: isDesktop }">
      <div class="pricing-wrap">
        <v-row justify="center">
          <v-col
            cols="12"
            md="6"
            lg="5"
            xl="4"
            style="max-width: 500px"
            class="item"
            v-for="(item, i) in items"
            :key="item.id"
            :order="items.length - i"
            :order-md="i + 1"
          >
            <PricingCard
              :class="{ value: item.featured }"
              v-bind="$attrs"
              :features="getFeatures(item.type)"
              :disabled-features="getFeatures(item.type, true)"
              :price="item.price"
              :interval="interval"
              :title="item.title"
              :description="item.description"
              :package-type="item.type"
              :full="full"
              :preceding-package-title="getPrecedingPackageTitle(item)"
            >
              <template #alert-area="slotProps">
                <slot v-bind="slotProps" name="alert-area"></slot>
              </template>
              <template #button-area>
                <slot name="button-area">
                  <div>
                    <base-btn
                      v-if="item.type === 'pro'"
                      :to="{
                        name: 'purchase-subscription-plan',
                        params: { id: item.id },
                      }"
                      :color="item.type === 'basic' ? 'secondary' : 'primary'"
                      class="button"
                      large
                    >
                      <span v-t="'Find out more'" />
                    </base-btn>
                    <div v-else-if="getIsDisabled(item.type)"></div>
                    <base-btn
                      v-else-if="getIsActive(item.type)"
                      class="button"
                      large
                      color="success"
                      readonly
                      disabled
                    >
                      <span v-t="'Current plan'" />
                    </base-btn>
                    <base-btn
                      v-else
                      :to="{
                        name: 'purchase-subscription-plan',
                        params: { id: item.id },
                      }"
                      :color="item.type === 'basic' ? 'secondary' : 'primary'"
                      class="button"
                      large
                    >
                      <span v-if="getCanChange(item.type)" v-t="'Other plans'" />
                      <span v-else v-t="'Order now'" />
                    </base-btn>
                  </div>
                </slot>
              </template>
            </PricingCard>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "@/_shared/scss/saas/dependencies.scss";

.root {
  position: relative;
  // z-index: 55;
}

.subtitle {
  margin-bottom: $spacing5;
}

.decoration {
  position: absolute;
  width: 1280px;
  height: 960px;
  svg {
    width: 1280px;
    height: 100%;
    // fill: purple;
    @include use-theme(fill, $palette-primary-light, $palette-primary-dark);
    opacity: 0.2;
    @include breakpoints-up(lg) {
      transform: scale(1.7, 1);
    }
    @include breakpoints-up(xl) {
      display: none;
    }
    @include breakpoints-down(xs) {
      transform: scale(0.5);
      transform-origin: center left;
    }
  }
}

.item {
  &:hover {
    z-index: 56 !important;
  }
}

.pricing-wrap > section {
  align-items: center;
  margin-top: $spacing3;
  display: flex;
  @include breakpoints-down(sm) {
    flex-wrap: wrap;
    justify-content: space-around;
  }
  @include breakpoints-up(lg) {
    padding: spacing(0, 5);
  }
  > * {
    margin: 0 -8px;
  }
  > *:first-child,
  & > *:last-child {
    z-index: 50;
  }
}
</style>

<script>
import PricingCard from "./PricingCard";

export default {
  components: {
    PricingCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    interval: {
      type: String,
      required: true,
    },
    full: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isDesktop() {
      return !this.$vuetify.breakpoint.mobile;
    },
    currentPlanType() {
      return this._.get(this.$store.getters, ["subscription/currentPlan", "type"]);
    },
  },

  methods: {
    getIsActive(type) {
      if (!this.currentPlanType) return type === "basic";
      return this.currentPlanType === type;
    },
    getCanChange(type) {
      if (type === "pro" && this.currentPlanType === "best") return true;
      return false;
    },
    getIsDisabled(type) {
      if (!this.currentPlanType) {
        return false;
      }
      if (type === "basic") return true;
    },
    getFeatures(type, disabled = false) {
      if (!this.full && disabled) {
        return [];
      } else if (!this.full) {
        return this.items.find((item) => item.type === type).features;
      }

      const enabled = {
        basic: ["basic"],
        full: ["basic", "full"],
        // pro: ["basic", "best", "pro"],
      };
console.log(type)
      const items = disabled
        ? this.items.filter((item) => !enabled[type].includes(item.type))
        : this.items.filter((item) => enabled[type].includes(item.type));

      let features = [];
      items.forEach((item) => {
        features = features.concat(item.features);
      });

      return features;
    },
    getPrecedingPackageTitle(item) {
      if (!item) return null;
      const preceding = this.items.find((el) => el.type === item.preceding_package);
      return this._.get(preceding, ["title"]);
    },
  },
};
</script>
